export default "__VITE_ASSET__BqMUQYvL__"